import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  Slide,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Tooltip,
  IconButton,
  CircularProgress,
  Avatar,
  Divider,
  Box,
  Paper,
  Card,
  Grid,
  Chip,
  Menu,
  MenuItem,
} from "@material-ui/core";
// import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import "moment-timezone";
import { schedulerColor } from "../config";
import { CgArrowsExchangeAltV } from "react-icons/cg";
import { data_not_found } from "../icons";

const styles = (theme) => ({
  dialog: {
    margin: "0px 0px 0px auto",
    right: "0px",
    left: "auto",
    [theme.breakpoints.up("md")]: {
      width: "25%",
    },
    minWidth: "340px",
  },
  DialogTitle: {
    padding: "10px 24px",
  },
  myTitle: {
    float: "left",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: "18px",
    marginTop: "9px",
  },
  closeIcon: {
    padding: "10px 22px",
    color: "#ffffff",
    cursor: "pointer",
    float: "right",
    width: "50px",
    height: "50px",
  },
  saveButton: {
    color: "white",
    padding: "10px 22px",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  dialogContent: {
    backgroundColor: "#f5f5f5",
    padding: "1.5rem",
  },
  avatar: {
    // backgroundColor:  "#6200ea",
    backgroundImage: schedulerColor.main || "#6200ea",
    color: "white",
    width: 30,
    height: 30,
    fontSize: 20,
  },
  infoContainer: {
    // marginTop: "15px",
    // padding: "10px",
    // backgroundColor: "white",
    // borderRadius: "8px",
  },
  detailsContainer: {
    position: "relative",
    backgroundColor: "white",
    borderRadius: "12px",
    overflow: "hidden",
    display: "flex",
  },
  dateTimeBox: {
    backgroundImage: schedulerColor.main,
    boxShadow: "inset 4px 4px 10px rgba(0,0,0,0.3)",
    display: "flex",
    minWidth: "100px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const WhiteCard = ({ bgColor, children, styles }) => (
  <Card
    style={{
      // backgroundColor: "white",
      backgroundImage: bgColor || "gray",
      borderRadius: "8px",
      padding: "10px",
      ...styles,
    }}
  >
    {children}
  </Card>
);

// Helper function to format dates consistently with timezone
const formatDateTime = (time, timezone, pattern = "dddd MMM DD, hh:mm A") => {
  if (!time) return "";
  return moment.utc(time).tz(timezone).locale("en").format(pattern);
};

// Helper function for time only
const formatTime = (time, timezone, pattern = "hh:mm:ss A") => {
  if (!time) return "";
  return moment.utc(time).tz(timezone).locale("en").format(pattern);
};

const requestTitle = (request, shiftUser = "Someone") => {
  if (!request || !request.type) return "Invalid request type";

  switch (request.type) {
    case "cover":
      return "You have requested to cover this shift";

    case "timeoff":
      return "You have requested time off for this shift";

    case "trade":
      return `You have requested to trade this shift`;

    case "receiver_trade":
      return `${shiftUser} has requested to trade this shift`;

    default:
      return "";
  }
};

const TradeRequestDetails = ({ shift, tradeRequest, timezone }) => (
  <>
    <Box display="flex" alignItems="center" gap={4}>
      <Avatar
        style={{
          height: 25,
          width: 25,
          marginRight: 10,
        }}
        src={shift?.user_image || "/default-profile.png"}
      />
      <Box>
        <Typography variant="body2" color="textSecondary">
          you would work this shift
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {formatDateTime(tradeRequest?.startTime, timezone)} -{" "}
          {formatTime(tradeRequest?.endTime, timezone)}
        </Typography>
      </Box>
    </Box>
    <div
      style={{
        width: "100%",
        position: "relative",
        margin: "10px 0",
      }}
    >
      <Divider sx={{ my: 2, width: "100%" }} />
      <div
        style={{
          position: "absolute",
          right: "10px",
          bottom: "-10px",
          backgroundImage: schedulerColor.main,
          borderRadius: "100px",
          width: "20px",
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CgArrowsExchangeAltV style={{ color: "white", fontSize: "16px" }} />
      </div>
    </div>
    <Box display="flex" alignItems="center" gap={4}>
      <Avatar
        style={{
          height: 25,
          width: 25,
          marginRight: 10,
        }}
        src={tradeRequest?.user_image || "/default-profile.png"}
      />
      <Box>
        <Typography variant="body2" color="textSecondary">
          {tradeRequest?.user_name} would work your shift
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {formatDateTime(shift?.startTime, timezone)} -{" "}
          {formatTime(shift?.endTime, timezone)}
        </Typography>
      </Box>
    </Box>
  </>
);

const CoverRequestDetails = ({ shift, coverRequest, timezone }) => (
  <Box display="flex" alignItems="center" gap={4}>
    <Avatar
      style={{
        height: 25,
        width: 25,
        marginRight: 10,
      }}
      src={coverRequest?.user_image || "/default-profile.png"}
    />
    <Box>
      <Typography variant="body2" color="textSecondary">
        {coverRequest?.user_name} would work this shift
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {formatDateTime(shift?.startTime, timezone)} -{" "}
        {formatTime(shift?.endTime, timezone)}
      </Typography>
    </Box>
  </Box>
);

const TimeoffRequestDetails = ({ timeoffRequest, timezone }) => (
  <Box display="flex" alignItems="center" gap={4}>
    <Avatar
      style={{
        height: 25,
        width: 25,
        marginRight: 10,
      }}
      src={timeoffRequest?.user_image || "/default-profile.png"}
    />
    <Box>
      <Typography variant="body2" color="textSecondary">
        {timeoffRequest?.user_name} would be on time off between
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {formatDateTime(timeoffRequest?.startTime, timezone)} -{" "}
        {formatTime(timeoffRequest?.endTime, timezone)}
      </Typography>
    </Box>
  </Box>
);

const BaseRequestDetails = ({ shift, baseRequest, timezone }) => {
  const getStatusText = (request) => {
    if (request?.isTimeoffStatus === 2) return "Rejected";
    if (request?.isCoverStatus === 2) return "Rejected";
    if (request?.isTradeStatus === 2) return "Rejected";
    if (request?.isDiscarded) return "Discarded";
    if (request?.isTimeoffStatus === 1) return "Approved";
    if (request?.isCoverStatus === 1) return "Approved";
    if (request?.isTradeStatus === 1) return "Approved";
    return "Pending";
  };

  const getStatusColor = (status, isDiscarded) => {
    if (isDiscarded) return "red";
    return status === 1 ? "green" : status === 2 ? "red" : "black";
  };

  const renderRequestDetails = () => {
    if (baseRequest.type === "trade" || baseRequest.type === "receiver_trade") {
      return (
        <TradeRequestDetails
          shift={shift}
          tradeRequest={baseRequest}
          timezone={timezone}
        />
      );
    } else if (baseRequest.type === "cover") {
      return (
        <CoverRequestDetails
          shift={shift}
          coverRequest={baseRequest}
          timezone={timezone}
        />
      );
    } else if (baseRequest.type === "timeoff") {
      return (
        <TimeoffRequestDetails
          timeoffRequest={baseRequest}
          timezone={timezone}
        />
      );
    }
    return null;
  };

  return (
    <Box my={2}>
      <Typography variant="h6" color="textPrimary">
        {requestTitle(baseRequest, baseRequest.user_name)}{" "}
        <Typography
          variant="body2"
          color="textSecondary"
          style={{
            color: getStatusColor(
              baseRequest?.isTimeoffStatus,
              baseRequest?.isDiscarded
            ),
            textTransform: "uppercase",
          }}
        >
          ({getStatusText(baseRequest)})
        </Typography>
      </Typography>
      <WhiteCard bgColor>{renderRequestDetails()}</WhiteCard>
    </Box>
  );
};

// Break history details component with proper timezone handling
const BreakHistoryDetails = ({ breaks_activity, timezone }) => {
  if (!breaks_activity || breaks_activity.length === 0) {
    return null;
  }

  // Sort breaks by start time (newest first)
  const sortedBreaks = [...breaks_activity].sort(
    (b, a) => new Date(b.break_start) - new Date(a.break_start)
  );

  return (
    <Box mt={2}>
      <Typography
        variant="subtitle1"
        style={{ fontWeight: 600, marginBottom: "8px" }}
      >
        Break History
      </Typography>
      {sortedBreaks.map((breakItem, index) => {
        // Format break time (could be string or number)
        const breakTimeHours = parseFloat(breakItem.break_time).toFixed(2);

        return (
          <Box
            key={breakItem._id || index}
            mb={index !== sortedBreaks.length - 1 ? 2 : 0}
          >
            <Typography variant="body2">
              <b>Break {index + 1}:</b>{" "}
              {formatTime(breakItem.break_start, timezone)} -{" "}
              {breakItem.break_end
                ? formatTime(breakItem.break_end, timezone)
                : "Ongoing"}{" "}
              ({breakTimeHours} hrs)
            </Typography>
            {
              !breakItem.auto_generated ?
                <>
                  <Typography variant="caption" color="textSecondary">
                    Started from: {breakItem.break_start_device || "unknown"} •{" "}
                    {breakItem.break_end
                      ? `Ended from: ${breakItem.break_end_device || "unknown"}`
                      : "Ongoing"}
                  </Typography>
                </>
                :
                <Typography variant="caption" color="textSecondary" style={{ fontStyle: 'italic' }}>
                  Auto Added Break
                </Typography>
            }
            {index !== sortedBreaks.length - 1 && (
              <Divider style={{ marginTop: "8px" }} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

class MyRightModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuAnchor: null,
    };
  }

  createCorrection = () => {
    const { history, data, timezone } = this.props;
    if (!history) {
      return;
    }

    const shiftMoment = data?.currentDate
      ? moment.utc(data.currentDate)
      : data?.startTime
      ? moment.utc(data.startTime)
      : null;

    const localizedDate =
      shiftMoment && timezone ? shiftMoment.clone().tz(timezone) : shiftMoment;
    const occuranceDate = localizedDate
      ? localizedDate.format("YYYY-MM-DD")
      : null;

    const shiftPayload = {
      shiftId: data?._id || data?.shift_id || data?.job_id || null,
      jobId: data?.job_id || null,
      occuranceDate,
      startTime: data?.startTime || null,
      endTime: data?.endTime || null,
      clock_in: data?.clock_in || null,
      clock_out: data?.clock_out || null,
    };

    history.push({
      pathname: "/scheduler/correction-request/my/create/shift_adjustment",
      state: {
        prefilledShift: shiftPayload,
      },
    });
  };

  renderLoader = () => {
    const { classes } = this.props;
    return (
      <div className={classes.loaderContainer}>
        <CircularProgress />
      </div>
    );
  };

  handleMenuOpen = (e) => {
    this.setState({ menuAnchor: e });
  };

  handleMenuClose = () => {
    this.setState({ menuAnchor: null });
  };

  renderContent = () => {
    const {
      classes,
      children,
      data,
      clockInShift,
      clockoutShift,
      breakStartShift,
      endBreakShift,
      openTimeoffMenu,
      openCoverMenu,
      openTradeMenu,
      bgColor,
      editShifts,
      timezone,
    } = this.props;

    const { menuAnchor } = this.state;

    if (!data) return this.renderLoader();

    const displayData = data;

    const open = Boolean(menuAnchor);
    const popoverId = open ? "simple-popover" : undefined;

    const tradeRequests = displayData?.tradeRequest || [];
    const coverRequests = displayData?.coverRequest || [];
    const timeoffRequests = displayData?.timeoffRequest || [];
    const receiverTradeRequests = displayData?.receiver_trade || [];
    const shiftIssues = displayData?.shift_issues || []

    const requests = [
      ...tradeRequests.map((req) => ({ ...req, type: "trade" })),
      ...coverRequests.map((req) => ({ ...req, type: "cover" })),
      ...timeoffRequests.map((req) => ({ ...req, type: "timeoff" })),
      ...receiverTradeRequests.map((req) => ({
        ...req,
        type: "receiver_trade",
      })),
    ];

    const hasRequest =
      displayData?.coverRequest?.some(
        (req) => req?.isCoverStatus === 0 && req?.isDiscarded !== 1
      ) ||
      displayData?.tradeRequest?.some(
        (req) => req?.isTradeStatus === 0 && req?.isDiscarded !== 1
      ) ||
      displayData?.receiver_trade?.some(
        (req) => req?.isTradeStatus === 0 && req?.isDiscarded !== 1
      );

    const hasTimeoffRequest = displayData?.timeoffRequest?.some(
      (req) => req?.isTimeoffStatus !== 2 && req?.isDiscarded !== 1
    );

    // Use timezone for date comparisons
    const now = moment().tz(timezone);
    const startTimeMoment = moment.utc(displayData?.startTime).tz(timezone);
    const endTimeMoment = moment.utc(displayData?.endTime).tz(timezone);

    const hasShiftStarted =
      startTimeMoment.isBefore(now) || displayData?.clock_in !== null;

    const isRequestDisabled = displayData?.isPublished === 0 || hasRequest;

    const isEmergencyOn =
      (displayData?.clock_in !== null &&
        displayData?.clock_out === null &&
        now.isBefore(endTimeMoment)) ||
      (displayData?.clock_in === null &&
        now.isAfter(startTimeMoment) &&
        now.isBefore(endTimeMoment));

    const isShiftEnded =
      (displayData?.clock_in !== null && displayData?.clock_out !== null) ||
      now.isAfter(endTimeMoment);

    const isNoShowStatus = displayData?.statusLabel === "No Show";

    const buttonStyles = (isDisabled, bgColor, textColor) => ({
      backgroundImage: isDisabled ? "none" : bgColor || "gray",
      backgroundColor: isDisabled
        ? "rgba(200, 200, 200, 0.5)"
        : bgColor || "gray",
      fontWeight: 700,
      fontStyle: "initial",
      textTransform: "capitalize",
      color: isDisabled ? "#ccc" : textColor || "white",
      fontSize: "14px",
    });

    let shiftDate = "";
    if (displayData?.startTime) {
      shiftDate = formatDateTime(
        displayData.startTime,
        timezone,
        "dddd, MMMM DD, YYYY"
      );
    }

    let startTime = "";
    let endTime = "";
    if (displayData?.startTime) {
      startTime = formatTime(displayData.startTime, timezone);
    }
    if (displayData?.endTime) {
      endTime = formatTime(displayData.endTime, timezone);
    }

    // Check if shift is over the next day
    const isNextDay = () => {
      if (!displayData?.startTime || !displayData?.endTime) return false;

      const startDate = moment
        .utc(displayData.startTime)
        .tz(timezone)
        .format("YYYY-MM-DD");
      const endDate = moment
        .utc(displayData.endTime)
        .tz(timezone)
        .format("YYYY-MM-DD");

      return startDate !== endDate;
    };

    // Get current status of the shift
    const getShiftStatus = () => {
      // Not started yet
      if (!displayData?.clock_in && startTimeMoment.isAfter(now)) {
        return "not_started";
      }

      // Started but not ended
      if (displayData?.clock_in && !displayData?.clock_out) {
        return "in_progress";
      }

      // Ended
      if (displayData?.clock_out) {
        return "completed";
      }

      // Default - schedulable but not started
      return "schedulable";
    };

    const status = getShiftStatus();
    const nextDay = isNextDay();

    return (
      <>
        <DialogContent className={classes.dialogContent} dividers>
          {!displayData ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="dsa"
                src={data_not_found}
                style={{
                  width: "300px",
                  aspectRatio: "auto",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : (
            <>
              <div className={classes.detailsContainer}>
                <div className={classes.dateTimeBox}>
                  <Typography variant="h2" style={{ color: "white" }}>
                    {formatDateTime(displayData?.currentDate, timezone, "MMM")}
                  </Typography>
                  <Typography
                    variant="h2"
                    style={{ fontWeight: 700, color: "white" }}
                  >
                    {formatDateTime(displayData?.currentDate, timezone, "DD")}
                  </Typography>
                  <Typography variant="h2" style={{ color: "white" }}>
                    {formatDateTime(displayData?.currentDate, timezone, "ddd")}
                  </Typography>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ padding: 10 }}>
                    <Typography variant="h6" style={{ fontWeight: 700 }}>
                      {displayData?.user_name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {displayData?.location_name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {displayData?.role_name}
                    </Typography>
                    {displayData?.startTime && (
                      <Typography variant="body2" style={{ fontWeight: 700 }}>
                        Time: {startTime} - {endTime}
                        {nextDay && (
                          <span style={{ color: "red" }}> (Next Day)</span>
                        )}
                      </Typography>
                    )}
                    {displayData?.location_name && (
                      <Typography variant="body2" style={{ fontWeight: 700 }}>
                        Location: {displayData.location_name}
                      </Typography>
                    )}
                    <Typography variant="body2" style={{ fontWeight: 700 }}>
                      Total Scheduled Hours:{" "}
                      {displayData?.total_scheduled_hrs || 0} hrs
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 700 }}>
                      Notes: {displayData?.shift_notes || "No Notes"}
                    </Typography>
                  </div>
                </div>
              </div>

              <WhiteCard styles={{ marginTop: "20px", display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: 600, marginBottom: "8px" }}
                >
                  Shift Status
                </Typography>
                {displayData?.is_auto_clock_out ?
                  (<Typography style={{border:'1px solid #aa076b',marginLeft:'auto', padding:'1px 6px', borderRadius:'20px',fontSize:"12px", fontWeight:"600",marginBottom:'0', width:"fit-content", color:'#aa076b'}}>
                    Auto Clocked Out
                  </Typography>)
                  :
                  null
                }
                {displayData?.clock_in && (
                  <Typography variant="body2">
                    <b style={{color: '#000'}}>Clocked in at:</b> {formatDateTime(displayData.clock_in, timezone)}
                  </Typography>
                )}
                
                {displayData?.break_start && !displayData?.break_end && (
                  <Typography variant="body2">
                    On break since:{" "}
                    {formatTime(displayData.break_start, timezone)}
                  </Typography>
                )}
                {displayData?.clock_out && (
                  <Typography variant="body2">
                    <b style={{color: '#000'}}>Clocked out at:</b>{" "}
                    {formatDateTime(displayData.clock_out, timezone)}
                  </Typography>
                )}
                {now.isAfter(startTimeMoment) &&
                  !displayData?.clock_in &&
                  now.isBefore(endTimeMoment) && (
                    <Typography variant="body2" style={{ color: "#f44336" }}>
                      Shift has started but not clocked in yet
                    </Typography>
                  )}
                {now.isAfter(endTimeMoment) && (
                  <Typography variant="body2" color="error">
                    Shift has ended
                  </Typography>
                )}
                {(now.isBefore(startTimeMoment) && !displayData?.clock_in ) && (
                  <Typography variant="body2" color="primary">
                    Shift has not started yet
                  </Typography>
                )}
                {displayData?.breaks_activity &&
                  displayData.breaks_activity.length > 0 && (
                    <BreakHistoryDetails
                      breaks_activity={displayData.breaks_activity}
                      timezone={timezone}
                    />
                  )}
              </WhiteCard>

              {requests?.length > 0 &&
                requests?.map((request, index) => (
                  <BaseRequestDetails
                    key={index}
                    shift={displayData}
                    baseRequest={request}
                    bgColor
                    timezone={timezone}
                  />
                ))}
              
              {
                shiftIssues?.length > 0 &&
                <>
                  <div className="" style={{marginTop: '20px'}}><Typography variant="h4" style={{fontWeight: 700}}>Issues</Typography></div>
                  {shiftIssues?.map((issue)=>{
                    return(
                      <div className="" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '8px', padding: '10px', marginTop: '20px', background: '#fff', boxShadow:'0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'}}>
                        <div>
                          <Typography variant="body2" style={{color: '#000'}}>{issue?.issue}</Typography>
                          <Typography variant="body2">{issue?.time_string}</Typography>
                          <Typography variant="body2">{formatDateTime(issue?.issue_time, timezone)}</Typography>
                        </div>
                        <div>
                          <Typography variant="body2" style={{color: '#000'}}>Flagged as</Typography>
                          <Typography variant="body2">{issue?.user_fault ? 'User fault' : 'Not User’s fault'}</Typography>
                        </div>
                      </div>
                    )
                  })}
                </>
              }
            </>
          )}
        </DialogContent>

        {displayData?.isPublished && (
          <DialogActions style={{ justifyContent: "center" }}>
            <Box
              mt={2}
              display="flex"
              justifyContent="space-evenly"
              style={{ gap: "10px" }}
            >
              {!displayData?.clock_out &&
                (displayData?.clock_in === null ? (
                  !isNoShowStatus ? (
                    <Button
                      variant="outlined"
                      size="medium"
                      style={buttonStyles(
                        isRequestDisabled || isShiftEnded,
                        bgColor
                      )}
                      onClick={() => clockInShift(displayData)}
                      disabled={isRequestDisabled || isShiftEnded}
                    >
                      Clock In
                    </Button>
                  ) : <></>
                ) : displayData?.break_start === null ? (
                  <Button
                    variant="outlined"
                    size="small"
                    style={buttonStyles(
                      isRequestDisabled || isShiftEnded,
                      bgColor
                    )}
                    onClick={() => breakStartShift(displayData)}
                    disabled={isRequestDisabled || isShiftEnded || isNoShowStatus}
                  >
                    Take Break
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    size="medium"
                    style={buttonStyles(isRequestDisabled, bgColor)}
                    onClick={() => endBreakShift(displayData)}
                  >
                    Stop Break
                  </Button>
                ))}
              {
                (displayData?.create_correction) &&
                <div>
                    <Button
                        variant="outlined"
                        size="small"
                        style={{background:'linear-gradient(45deg, #AA076B, #9F0D9C)', color:'#fff', fontSize:'14px',padding:'5px 15px', textTransform:'capitalize'}}
                        onClick={this.createCorrection}
                      >
                        + Correction
                    </Button>
                </div>
              }
              {displayData?.clock_in !== null &&
                displayData?.clock_out === null &&
                displayData?.break_start === null && (
                  <Button
                    variant="outlined"
                    size="medium"
                    style={buttonStyles(false, bgColor)}
                    onClick={() => clockoutShift(displayData)}
                  >
                    Clock Out
                  </Button>
                )}
            </Box>

            {
              (displayData?.clock_out === null && displayData?.statusLabel !== "No Show") && 
              <Box mt={2} display="flex" justifyContent="center">
                <Button
                  variant="outlined"
                  size="medium"
                  style={buttonStyles(
                    isRequestDisabled || hasTimeoffRequest || isShiftEnded || isNoShowStatus,
                    "rgba(159, 13, 156, 0.25)",
                    "black"
                  )}
                  disabled={
                    isRequestDisabled || hasTimeoffRequest || isShiftEnded || isNoShowStatus
                  }
                  onClick={(event) => this.handleMenuOpen(event.currentTarget)}
                >
                  Can't Work 
                </Button>
                <Menu
                  id={popoverId}
                  anchorEl={menuAnchor}
                  open={Boolean(menuAnchor)}
                  onClose={() => this.handleMenuClose(null)}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    disabled={isRequestDisabled || hasShiftStarted}
                    onClick={() => {
                      openCoverMenu();
                      this.handleMenuClose(null);
                    }}
                  >
                    Cover Shift
                  </MenuItem>
                  <MenuItem
                    disabled={isRequestDisabled || hasShiftStarted}
                    onClick={() => {
                      openTradeMenu();
                      this.handleMenuClose(null);
                    }}
                  >
                    Trade Shift
                  </MenuItem>
                  <MenuItem
                    disabled={isRequestDisabled}
                    onClick={() => {
                      openTimeoffMenu(isEmergencyOn);
                      this.handleMenuClose(null);
                    }}
                  >
                    Time Off
                  </MenuItem>
                </Menu>
              </Box>
            }
          </DialogActions>
        )}
      </>
    );
  };

  render() {
    const { classes, open, onClose, title, bgColor, loading } = this.props;

    return (
      <Dialog
        className={classes.dialog}
        maxWidth="sm"
        fullScreen
        open={open || false}
        onClose={onClose}
        TransitionComponent={Transition}
      >
        <DialogTitle
          style={{
            backgroundColor: bgColor || "gray",
            backgroundImage: bgColor || "gray",
            fontWeight: 700,
            fontStyle: "initial",
          }}
          className={classes.DialogTitle}
        >
          <Typography className={classes.myTitle} variant="h4">
            {title}
          </Typography>
          <Tooltip arrow title="Close">
            <IconButton
              className={classes.closeIcon}
              size="small"
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        {loading ? this.renderLoader() : this.renderContent()}
      </Dialog>
    );
  }
}

export default withRouter(withStyles(styles)(MyRightModal));
